import React from 'react'
import HeroImg from '../../../assets/images/company-formation/offshore-company-formation/hero-img.png'
import BannerImg from '../../../assets/images/company-formation/offshore-company-formation/banner-img.png'
import BreadCrumbs from "../../../components/BreadCrumbs/BreadCrumbs";
import HeroRightImage from "../../../components/Constant/HeroRightImage/HeroRightImage";
import BannerPageImg from "../../../components/Constant/Banner Page Img/BannerPageImg";
import PageList from "../../../components/Constant/List/List";
import { TiTick } from "react-icons/ti";
import { GoDotFill } from "react-icons/go";
import Button from "../../../components/Constant/button/Button";
import FAQList from "../../../components/Constant/FAQCard/FAQCard";
import Testimonials from "../../../components/Constant/Testimonials/Testimonials";
import CTA from "../../../components/Constant/cta/CTA";
import SEO from "../../../utils/SEO";

const BreadCrumbsData = [
    {name: 'Offshore Advisory', link: '/'},
    {
        name: 'UK Company Formation',
        link: '/indonesia-company-formation',
    },
]

function PanamaCompanyFormation() {
    return (
        <main className='main'>
            <SEO
                title="Panama Company Formation | Offshore Corporation Setup"
                description="Incorporate a Panama S.A. company for tax neutrality, asset protection, and global business operations in a leading offshore jurisdiction."
                keywords="Panama company formation, Panama corporation S.A., offshore company Panama, Panama incorporation, asset protection Panama, Panama holding company, offshore jurisdiction Panama, business setup Panama"
                url="/panama-company-formation"
            />
            <section className='section'>
                <BreadCrumbs data={BreadCrumbsData}/>

                <div className='container'>
                    <h1 className='section-title'>Panama Company Formation</h1>
                    <br/>
                    <div className='grid-container'>
                        <div className='flex-start'>
                            <h3 className='page-subtitle'>Incorporate in Latin America’s Leading Offshore Jurisdiction</h3>
                            <p className='page-paragraph'>
                                A <b> Panama Corporation (S.A.)</b> offers entrepreneurs and <b> investors privacy, tax neutrality, and global recognition.</b> With a long-standing history as a <b> financial and shipping hub, </b> Panama is a trusted choice for <b> wealth management, offshore banking, and corporate holding structures.</b>                            </p>

                            <PageList
                                items={[
                                    {
                                        title: "Global Recognition",
                                        icon: TiTick,
                                    },
                                    {
                                        title: "Asset Protection",
                                        icon: TiTick,
                                    },
                                    {
                                        title: "Flexible Structure",
                                        icon: TiTick,
                                    },
                                    {
                                        title: "Banking Hub",
                                        icon: TiTick,
                                    },
                                ]}
                            />

                            <Button
                                text="Request a Panama Company Formation Proposal →"
                                link="/consultation"
                                type="primary"
                                size="large"
                            />
                        </div>

                        <HeroRightImage src={HeroImg}/>
                    </div>
                    <BannerPageImg src={BannerImg}/>
                    <br/><br/>

                    <div className='flex-start'>
                        <h3 className='page-title'>Why Incorporate in Panama?</h3>
                        <PageList
                            items={[
                                {
                                    title: "Global Offshore Leader",
                                    paragraph: "One of the world’s most recognized offshore jurisdictions",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "Tax Benefits",
                                    paragraph: "0% tax on offshore-sourced income",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "Asset Protection",
                                    paragraph: "Strong legal framework for protecting wealth",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "Banking Hub",
                                    paragraph: "Panama is home to 70+ international banks",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "Strategic Location",
                                    paragraph: "Connects North & South America, Europe, and Asia",
                                    icon: GoDotFill,
                                },
                            ]}
                        />

                        <h3 className='page-title'>Key Features of a Panama Corporation (S.A.)</h3>
                        <PageList
                            items={[
                                {
                                    title: "100% foreign ownership allowed",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "Minimum 3 directors",
                                    paragraph: "Can be individuals or corporate",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "No minimum paid-up capital required",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "Bearer shares permitted",
                                    paragraph: "With custodian",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "Local registered agent and office required",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "Flexible share classes",
                                    paragraph: "Common, preferred, registered, or bearer",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "No restrictions on business activities abroad",
                                    icon: GoDotFill,
                                },
                            ]}
                        />

                        <h3 className='page-title'>Benefits of Panama Companies</h3>
                        <PageList
                            items={[
                                {
                                    title: "Tax-Neutral",
                                    paragraph: "No local tax on offshore activities",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "Confidentiality",
                                    paragraph: "Ownership privacy protected",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "Banking Access",
                                    paragraph: "One of the strongest offshore banking networks",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "Asset Holding",
                                    paragraph: "Ideal for real estate, IP, or corporate holdings",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "Shipping & Maritime",
                                    paragraph: "Widely used for vessel registration",
                                    icon: GoDotFill,
                                },
                            ]}
                        />

                        <h3 className='page-title'>
                            Incorporation Requirements
                        </h3>
                        <PageList
                            items={[
                                {
                                    title: "At least 3 directors and 1 shareholder",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "Registered office and local registered agent",
                                    paragraph: "Required in Panama",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "Annual franchise tax",
                                    paragraph: "USD 300",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "KYC documents",
                                    paragraph: "Passport, proof of address, CV",
                                    icon: GoDotFill,
                                },
                            ]}
                        />

                        <h3 className='page-title'>
                            Incorporation Process
                        </h3>
                        <PageList
                            items={[
                                {
                                    title: "Consultation & Structuring",
                                    paragraph: "Define company structure & shareholding",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "Name Reservation",
                                    paragraph: "Check availability with Panama Public Registry",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "Articles of Incorporation",
                                    paragraph: "Notarized and filed",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "Registration",
                                    paragraph: "Company approved by Public Registry",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "Certificate of Incorporation issued",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "Optional Add-Ons",
                                    paragraph: "Nominee directors, apostille, bank accounts",
                                    icon: GoDotFill,
                                },
                            ]}
                        />

                        <h3 className='page-title'>
                            Timeline & Costs
                        </h3>
                        <PageList
                            items={[
                                {
                                    title: "Timeline",
                                    paragraph: "5–10 business days",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "Setup Cost",
                                    paragraph: "From USD 2,500+",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "Annual Renewal",
                                    paragraph: "USD 300 franchise tax + agent/office fees",
                                    icon: GoDotFill,
                                },
                            ]}
                        />

                        <h3 className='page-title'>Common Uses of Panama Companies</h3>
                        <PageList
                            items={[
                                {
                                    paragraph: "International trade & e-commerce",
                                    icon: GoDotFill,
                                },
                                {
                                    paragraph: "Asset protection & estate planning",
                                    icon: GoDotFill,
                                },
                                {
                                    paragraph: "Banking & investment holding",
                                    icon: GoDotFill,
                                },
                                {
                                    paragraph: "Maritime & shipping registration",
                                    icon: GoDotFill,
                                },
                                {
                                    paragraph: "Wealth management structures",
                                    icon: GoDotFill,
                                },
                            ]}
                        />

                        <h3 className='page-title'>
                            Why Offshore Advisory?
                        </h3>
                        <PageList
                            items={[
                                {
                                    title: "Specialists in Panama incorporation & banking",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "Access to Panama-based law firms & registered agents",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "Expertise in shipping, trusts, and financial services licensing",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "Comparative insights",
                                    paragraph: "Panama vs BVI vs Seychelles vs Belize",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "Ongoing compliance & tax advisory support",
                                    icon: GoDotFill,
                                },
                            ]}
                        />

                    </div>


                    <FAQList title='Frequently Asked Questions (FAQ)' data={faqData} />

                    <Testimonials title='Client Testimonials' testimonials={testimonialsData}/>

                    <CTA
                        title="Looking for a globally recognized offshore company?"
                        description="A <b>Panama Corporation (S.A.)</b> offers asset protection, privacy, and tax neutrality in one of the world’s strongest offshore jurisdictions."
                        buttonText="Book a Panama Company Formation Consultation →"
                        buttonLink="/consultation"
                    />
                </div>
            </section>
        </main>
    )
}

export default PanamaCompanyFormation

const faqData = [
    {
        question: "Do Panama companies pay tax?",
        content: [
            { type: "answer", text: "No — offshore income is tax-exempt." },
        ],
    },
    {
        question: "How many directors are required?",
        content: [
            { type: "answer", text: "Minimum of 3 directors (can be corporate)." },
        ],
    },
    {
        question: "Can foreigners own 100%?",
        content: [
            { type: "answer", text: "Yes — full foreign ownership is allowed." },
        ],
    },
    {
        question: "How long does incorporation take?",
        content: [
            { type: "answer", text: "Typically 5–10 business days." },
        ],
    },
    {
        question: "Do Panama companies need to file annual accounts?",
        content: [
            { type: "answer", text: "No — but they must pay the annual franchise tax." },
        ],
    },
];


const testimonialsData = [
    {
        quote:
            "We established a Panama company for international trading. Offshore Advisory handled incorporation and banking introductions.",
        author: "Alejandro G.",
        role: "Trader",
    },
    {
        quote:
            "Our family used a Panama corporation for estate planning. Offshore Advisory guided us with confidentiality and structure.",
        author: "Maria L.",
        role: "Investor",
    },
];